import { z } from 'zod'
import { firestoreTimestamp, firestoreWriteTimestamp } from '../shared/schema'

export const schema = z.object({
  productId: z.string(),
  productName: z.string(),
  sectionPassPrice: z.number().int(),
  sectionPassQuantity: z.number().int(),
  updatedAt: firestoreTimestamp,
})

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(
  schema.parse({
    productId: '',
    productName: '',
    sectionPassPrice: 0,
    sectionPassQuantity: 0,
    updatedAt: { seconds: 0, nanoseconds: 0 },
  })
)

export type FirestoreProduct = z.infer<typeof schema>
export type FirestoreProductWrite = z.infer<typeof writeSchema>
